<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  @if ((checkPermission(GlobalAuthority.MANAGE_BUILDINGS) | async) && (checkPermission(GlobalAuthority.MANAGE_USERS) | async)) {
    <mat-tab label="Users">
      <app-global-user/>
    </mat-tab>
  }

  @if (checkPermission(GlobalAuthority.MANAGE_GLOBAL_AUTHORITY_REQUEST) | async) {
    <mat-tab label="Global Authority Requests">
      <mat-card class="mat-elevation-z8 job-information-card">
        <app-global-authority-requests/>
      </mat-card>
    </mat-tab>
  }
</mat-tab-group>
